<template>
  <div class="bigtitle">
    {{bigtitle.CHN}}<span>{{bigtitle.ENG}}</span>
  </div>
</template>

<script>

export default {
  data () {
    return {
      options: {},
    };
  },
  components: {

  },
  props: {
    bigtitle: {
      type: Object,
      default: () => ({})
    },
  },
  watch: {
    
  },
}
</script>
<style lang="scss">
.bigtitle{
  font-family: 'PuHuiTi Heavy';
  font-size:40px;
  span{
    font-size:21px;
    margin-left:10px;
  }
}
</style>